module.exports = __webpack_public_path__ + "img/LETICIA.8b0c5023.jpeg";